import DOMPurify from "dompurify";
import { ref, watch } from "vue";
import i18n from "./index";
import catalog from "../locales/content.json";
import { createLiveTranslator } from "./live-translations.mjs";

const translations = new Map(catalog.entries.map((item) => [
  `${item.format}\u0000${item.source}`, item.translations,
]));

const revision = ref(0);
export { revision as contentTranslationRevision };
let storage;
try { storage = window.localStorage; } catch { /* cache in memory */ }
const liveTranslator = createLiveTranslator({
  endpoint: process.env.VUE_APP_TRANSLATION_URL || "/translations/translate",
  storage,
  batchSize: 16,
  onUpdate() {
    revision.value++;
  },
});
const privateTranslator = createLiveTranslator({
  endpoint: process.env.VUE_APP_TRANSLATION_URL || "/translations/translate",
  batchSize: 16, cacheOnServer: false,
  onUpdate() { revision.value++; },
});
watch(i18n.global.locale, (locale) => {
  liveTranslator.activate(locale);
  privateTranslator.activate(locale);
}, { immediate: true });

export function retryTranslations() { liveTranslator.retry(); privateTranslator.retry(); }

export function translatedPrivateContent(source) {
  if (typeof source !== "string") return typeof source === "number" || typeof source === "boolean" ? String(source) : "";
  const locale = i18n.global.locale.value;
  if (locale === "pt") return source;
  void revision.value;
  return translations.get(`text\u0000${source}`)?.[locale] || privateTranslator.get(source, locale);
}

export function translatedContent(source, format = "text") {
  if (typeof source !== "string") return typeof source === "number" || typeof source === "boolean" ? String(source) : "";
  const locale = i18n.global.locale.value;
  if (locale === "pt") return source;
  // Subscribe render/computed consumers to completed asynchronous translations.
  void revision.value;
  return translations.get(`${format}\u0000${source}`)?.[locale] || liveTranslator.get(source, locale, format);
}

export function translatedHtml(source, preserveLineBreaks = true) {
  const translated = translatedContent(source, "html");
  const html = preserveLineBreaks ? translated.replace(/\n/g, "<br>") : translated;
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
